const LeftArrow = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill={props.isDisabled ? '#747474' : '#270438'}
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => !props.isDisabled && props.onClick()}
    >
      <path
        d="M35 24L13 24M13 24L22.1765 32M13 24L22.1765 16"
        stroke={props.isDisabled ? '#747474' : '#270438'}
        strokeOpacity="1"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftArrow;
